import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/forms/Buttons/Button";
import { EyeIcon } from "@heroicons/react/24/outline";
import { EyeSlashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import Input from "../../components/forms/Input/Input";
import useAuth from "../../utils/hooks/useAuth";

export default function Login() {
  const { loginUser, error } = useAuth();
  const [t] = useTranslation();
  const navigate = useNavigate();

  const {
    // formState: { errors },
    register,
    handleSubmit,
  } = useForm();

  // const { user } = useContext(UserContext);
  // const { loginUser, error } = useAuth();

  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await loginUser(data).finally(() => {
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="pt-28 flex justify-center bg-slate-200 h-screen">
        <div className="flex flex-col gap-2 rounded-md border border-gray-300 bg-white p-8 h-fit">
          <h2 className="text-4xl font-bold mb-4 text-center text-primary">
            {t("welcome.login")}
          </h2>
          <div className="mb-4 space-y-2 text-sm text-gray-700">
            {/* <p className="font-semibold text-center">
              {t("welcome.login_welcome_message")}
            </p> */}
            <p className="text-sm text-gray-700">
              1-қадам. Жетекші ретінде ТІРКЕЛУ.
              <br />
              2-қадам. Топ құру.
              <br />
              3-қадам. Топқа оқушыларды қосу.
              <br />
              4-қадам. Топты олимпиадаға тіркеу.
            </p>
          </div>
          <form
            className="flex flex-col gap-2"
            onSubmit={handleSubmit((data) => {
              data.username = data.iin;
              onSubmit(data);
            })}
          >
            <Input
              label={t("auth.iin")}
              inputClassName="bg-white shadow-none outline-1 outline-gray-300 md:rounded-lg h-10"
              className="text-sm"
              name="iin_ana_tili_bil"
              type="text"
              placeholder={t("auth.enter_iin")}
              {...register("iin")}
            />
            <div className="relative">
              <Input
                label={t("welcome.password")}
                inputClassName="bg-white shadow-none outline-1 outline-gray-300 md:rounded-lg h-10"
                className="text-sm"
                type={isVisible ? "text" : "password"}
                placeholder={t("signup.enter_password")}
                {...register("password")}
              />
              <div
                className="absolute right-2 bottom-2.5 h-5 w-5 text-gray-500"
                onClick={() => setIsVisible(!isVisible)}
              >
                {isVisible ? <EyeSlashIcon /> : <EyeIcon />}
              </div>
            </div>
            <div className="rounded-lg overflow-hidden mt-2">
              <Button
                className="w-full text-base font-semibold"
                text={t("welcome.login")}
                color="primary"
                type="submit"
                loading={loading}
                disabled={loading}
              />
            </div>

            <span className="w-64 text-center text-error">
              {error?.data?.detail ===
              "No active account found with the given credentials"
                ? t("signup.no_active_account")
                : error?.data?.detail}
            </span>
          </form>

          <div className="border-t border-gray-300"></div>

          <div
            onClick={() => navigate("/password-reset")}
            className="text-center text-primary underline-none cursor-pointer"
          >
            {t("signup.forgot_password")}
          </div>

          <div
            onClick={() => navigate("/registration")}
            className="text-center text-primary underline-none cursor-pointer"
          >
            {t("signup.create_account")}
          </div>
        </div>
      </div>
    </div>
  );
}
